var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
      staticClass: "pb-8",
    },
    [
      _c("mini-header", {
        attrs: {
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: true,
          dense: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c("v-spacer"),
                _c(
                  "v-btn",
                  {
                    staticClass: "mr-2",
                    attrs: { color: "grey-900", outlined: "" },
                    on: { click: _vm.updatedView },
                  },
                  [
                    _c("v-img", {
                      attrs: {
                        contain: "",
                        src: require(`@/assets/icon-update${
                          _vm.$vuetify.theme.dark ? "-dark" : ""
                        }.svg`),
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "mr-2",
                    attrs: {
                      color: "grey-900",
                      to: {
                        name: "StoreSales",
                        params: { ..._vm.$route.params },
                      },
                      outlined: "",
                    },
                  },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [
                      _vm._v("mdi-store"),
                    ]),
                    _vm._v(" Métricas de tiendas "),
                  ],
                  1
                ),
                _c(
                  "v-menu",
                  {
                    attrs: {
                      "close-on-click": "",
                      "close-on-content-click": "",
                      "offset-y": "",
                      left: "",
                      "nudge-bottom": 10,
                      transition: "slide-y-transition",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "ml-2",
                                    attrs: { color: "grey-900" },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c("v-icon", { attrs: { left: "" } }, [
                                  _vm._v("mdi-calendar-blank "),
                                ]),
                                _vm._v(
                                  _vm._s(_vm.filter[_vm.selected.q] ?? "Fecha")
                                ),
                                _c(
                                  "v-icon",
                                  { attrs: { size: "18", right: "" } },
                                  [_vm._v("mdi-chevron-down")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c(
                      "v-list",
                      { staticClass: "pa-0" },
                      [
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected.q = "this_day"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Hoy")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected.q = "last_day"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Ayer")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected.q = "this_week"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Esta semana")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected.q = "last_week"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Semana pasada")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected.q = "this_month"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Este mes")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.selected.q = "last_month"
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "body-2 grey-500--text" },
                              [_vm._v("Mes pasado")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.loading
        ? [
            _c(
              "v-col",
              { staticClass: "pa-0", attrs: { cols: "12" } },
              [
                _c(
                  "v-row",
                  { staticClass: "mt-5 px-1" },
                  _vm._l(3, function (item) {
                    return _c(
                      "v-col",
                      { key: item, staticClass: "pa-0", attrs: { cols: "4" } },
                      [
                        _c("v-skeleton-loader", {
                          staticClass: "mt-n3 pa-2",
                          staticStyle: { "border-radius": "10px !important" },
                          attrs: {
                            transition: "fade-transition",
                            type: "list-item-two-line",
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "v-col",
              { staticClass: "mt-10 pa-0", attrs: { cols: "12" } },
              [
                _c(
                  "v-row",
                  { staticClass: "px-1" },
                  _vm._l(2, function (item) {
                    return _c(
                      "v-col",
                      { key: item, staticClass: "pa-0", attrs: { cols: "6" } },
                      [
                        _c("v-skeleton-loader", {
                          staticClass: "mt-n3 pa-2",
                          staticStyle: { "border-radius": "10px !important" },
                          attrs: {
                            transition: "fade-transition",
                            type: "image",
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]
        : [
            !_vm.hasData
              ? _c(
                  "v-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("empty-state", {
                      staticClass: "mt-10",
                      attrs: {
                        type: "metrics-branch",
                        id: "metrics",
                        height: 320,
                        title: "¿Quieres ver el monitor?",
                        description: "Filtra para obtener registros",
                        hiddenDescription: true,
                        isFree: true,
                      },
                    }),
                  ],
                  1
                )
              : [
                  _c(
                    "v-col",
                    { staticClass: "pa-0", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "mt-0 px-5 pt-5 pb-7",
                          attrs: { flat: "" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "d-block text-subtitle-2 grey-700--text font-weight-bold mb-5 ml-n1",
                            },
                            [_vm._v("Total de ventas")]
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0 px-2",
                                  attrs: { cols: "3" },
                                },
                                [
                                  _c("span", { staticClass: "d-block" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "font-weight-bold text-h4 grey-700--text",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$fmt.currency(
                                                _vm.accountCurrency,
                                                _vm.summary.net
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-subtitle-1 grey-500--text ml-1",
                                      },
                                      [_vm._v("Neto")]
                                    ),
                                  ]),
                                ]
                              ),
                              _c("v-divider", { attrs: { vertical: "" } }),
                              _c("v-spacer"),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0 px-2",
                                  attrs: { cols: "3" },
                                },
                                [
                                  _c("span", { staticClass: "d-block" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "font-weight-bold text-h4 grey-700--text",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$fmt.currency(
                                                _vm.accountCurrency,
                                                _vm.summary.igv
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-subtitle-1 grey-500--text ml-1",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$store?.state?.auth?.account
                                              ?.country !== "PE"
                                              ? "IVA"
                                              : "IGV"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _c("v-divider", { attrs: { vertical: "" } }),
                              _c("v-spacer"),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0 px-2",
                                  attrs: { cols: "3" },
                                },
                                [
                                  _c("span", { staticClass: "d-block" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "font-weight-bold text-h4 grey-700--text",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$fmt.currency(
                                                _vm.accountCurrency,
                                                _vm.summary.total
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-subtitle-1 grey-500--text ml-1",
                                      },
                                      [_vm._v("Total ")]
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "pa-0 mt-1", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-row",
                        { staticClass: "px-1 mt-4" },
                        [
                          _c(
                            "v-col",
                            { staticClass: "py-0 px-2", attrs: { cols: "6" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "pa-4 rounded-md",
                                  attrs: { flat: "" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-subtitle-2 grey-700--text font-weight-bold",
                                    },
                                    [_vm._v("Q Tickets")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-block mt-2 font-weight-bold text-h4 grey-700--text",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$fmt.integer(_vm.summary.count)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "py-0 px-2", attrs: { cols: "6" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "pa-4 rounded-md",
                                  attrs: { flat: "" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-subtitle-2 grey-700--text font-weight-bold",
                                    },
                                    [_vm._v("Ticket promedio")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-block mt-2 font-weight-bold text-h4 grey-700--text",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$fmt.currency(
                                              _vm.accountCurrency,
                                              _vm.summary.average_ticket
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-8 px-1" },
                        [
                          _c(
                            "v-col",
                            { staticClass: "py-0 px-2", attrs: { cols: "12" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "d-flex flex-column",
                                  attrs: { flat: "" },
                                },
                                [
                                  _c(
                                    "v-card-title",
                                    { staticClass: "pt-3 px-0" },
                                    [
                                      _c(
                                        "v-toolbar",
                                        {
                                          attrs: {
                                            color: "transparent",
                                            flat: "",
                                            height: "46",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-toolbar-title",
                                            {
                                              staticClass:
                                                "px-5 d-flex align-center subtitle-2 grey-500--text font-weight-semibold",
                                            },
                                            [_vm._v("Ventas")]
                                          ),
                                          _c("v-spacer"),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex pr-5" },
                                            [
                                              _c("v-sheet", {
                                                staticClass:
                                                  "d-flex mr-4 ml-1 rounded-sm",
                                                attrs: {
                                                  width: "7",
                                                  height: "14",
                                                  color: "grey-900",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 grey-500--text ml-n2",
                                                },
                                                [_vm._v("Ventas")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-card-text",
                                    { staticClass: "pb-4 flex-grow-1" },
                                    [
                                      _c("chart-line", {
                                        key: `line-${_vm.chartHeight}`,
                                        attrs: {
                                          "chart-data": _vm.salesChart,
                                          "show-legend": false,
                                          "month-label": _vm.salesMonth,
                                          "show-point": false,
                                          numberRounded:
                                            this.$store.state.auth.account
                                              .currency !== "CLP",
                                          currency: _vm.accountCurrency,
                                          height: _vm.chartHeight,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "mt-5 py-0 px-2",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "d-flex flex-column",
                                  attrs: { flat: "" },
                                },
                                [
                                  _c(
                                    "v-card-title",
                                    { staticClass: "pt-3 px-0" },
                                    [
                                      _c(
                                        "v-toolbar",
                                        {
                                          attrs: {
                                            color: "transparent",
                                            flat: "",
                                            height: "46",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-toolbar-title",
                                            {
                                              staticClass:
                                                "px-5 d-flex align-center subtitle-2 grey-500--text font-weight-semibold",
                                            },
                                            [_vm._v("Q-Promedio por ticket")]
                                          ),
                                          _c("v-spacer"),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex pr-5" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "d-flex" },
                                                [
                                                  _c("v-sheet", {
                                                    staticClass:
                                                      "d-flex mr-4 ml-1 rounded-sm",
                                                    attrs: {
                                                      width: "7",
                                                      height: "14",
                                                      color: "grey-900",
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-2 grey-500--text ml-n2",
                                                    },
                                                    [_vm._v("Q de tickets")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "d-flex ml-5" },
                                                [
                                                  _c("v-sheet", {
                                                    staticClass:
                                                      "d-flex mr-4 ml-1 rounded-sm",
                                                    attrs: {
                                                      width: "7",
                                                      height: "14",
                                                      color: "grey-900",
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-2 grey-500--text ml-n2",
                                                    },
                                                    [_vm._v("Ticket promedio")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-card-text",
                                    { staticClass: "pb-4 flex-grow-1" },
                                    [
                                      _c("chart-bar-line", {
                                        key: `bar-line-${_vm.chartHeight}`,
                                        attrs: {
                                          "chart-data": _vm.avgTicketChart,
                                          "x-axis-label": _vm.salesMonth,
                                          "show-legend": false,
                                          "x-axis-type": "date",
                                          currency: _vm.accountCurrency,
                                          height: _vm.chartHeight,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }